import {useTranslation} from "react-i18next";
// -
import IconBool from "components/IconBool";
import translations from "./translations";
import useCustomTranslation from "core/customTranslation";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableNTP = ({
    items,
    itemsShow,
    buttonsTB,
    setButtonsTB,
    checkAll,
    setCheckAll,
    orderingRef,
}) => {
    const {t: _TC} = useCustomTranslation(translations);

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "164px",
        backgroundColor: "white",
        zIndex: 899,
    };
    const getByModel = (item) => {
        switch (item.model) {
            case "MQ-SX":
                return (
                    <td>
                        <div>
                            <label className="text-muted">{_TC("ntp_server")}</label>:{" "}
                            <IconBool value={item.has.has_ntp_server} classAdd="mx-1" />{" "}
                            {item.values.ntp_server || "-"}
                        </div>
                        <div>
                            <label className="text-muted">{_TC("tz")}</label>:{" "}
                            <IconBool value={item.has.has_tz} classAdd="mx-1" />{" "}
                            {item.values.tz || "-"}
                        </div>
                        <div>
                            <label className="text-muted">{_TC("sync")}</label>:{" "}
                            <IconBool value={item.has.has_sync} classAdd="mx-1" />{" "}
                            {item.values.sync || "-"}
                        </div>
                    </td>
                );
            case "MQ2-4G":
                return (
                    <td>
                        <div>
                            <label className="text-muted">{_TC("url_1")}</label>:{" "}
                            <IconBool value={item.has.has_url_1} classAdd="mx-1" />{" "}
                            {item.values.url_1 || "-"}
                        </div>
                        <div>
                            <label className="text-muted">{_TC("url_2")}</label>:{" "}
                            <IconBool value={item.has.has_url_2} classAdd="mx-1" />{" "}
                            {item.values.url_2 || "-"}
                        </div>
                        <div>
                            <label className="text-muted">{_TC("url_3")}</label>:{" "}
                            <IconBool value={item.has.has_url_3} classAdd="mx-1" />{" "}
                            {item.values.url_3 || "-"}
                        </div>
                        <div>
                            <label className="text-muted">{_TC("url_4")}</label>:{" "}
                            <IconBool value={item.has.has_url_4} classAdd="mx-1" />{" "}
                            {item.values.url_4 || "-"}
                        </div>
                    </td>
                );
            default:
                return <></>;
        }
    };

    return (
        <table className="table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th
                        key="-1"
                        style={{
                            width: "0.4%",
                            verticalAlign: "bottom",
                            ...stickyHeaderStyle,
                        }}
                        className="sticky-top border-bottom-sticky">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} />
                </tr>
            </thead>
            <tbody id="data-list">
                {itemsShow.map((item) => (
                    <tr key={item.id} data-idx={item.id} onChange={onClick}>
                        <td className="align-middle">
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                key={item.id}
                                data-idx={item.id}
                                defaultChecked={items.current.chosen.includes(item.id)}
                                readOnly={true}
                            />
                        </td>
                        <td className="align-middle">{item.name}</td>
                        <td className="align-middle">{item.description}</td>
                        <td className="align-middle">{item.model}</td>
                        {getByModel(item)}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableNTP;
